import { Link } from 'react-router-dom';
import { featureArticles } from '@/mocks/seo-content';

export default function FeatureGrid() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-200 text-foreground-600 text-xs font-medium mb-4 whitespace-nowrap">
            Recursos
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 mb-3 leading-tight">
            Por que escolher
          </h2>
          <p className="text-2xl md:text-3xl font-heading font-extralight text-foreground-500">
            Hoobuy Sheet?
          </p>
          <p className="text-sm md:text-base text-foreground-500 font-light mt-4 max-w-[480px] mx-auto">
            Tudo o que precisa para fazer compras inteligentes e informadas na China.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featureArticles.map((article) => (
            <Link
              key={article.id}
              to={article.slug}
              className="group block rounded-2xl p-6 md:p-7 bg-background-50 border border-background-200/60 hover:bg-accent-50/50 hover:border-accent-200 transition-all duration-300"
            >
              <div className="w-11 h-11 rounded-xl bg-background-100 flex items-center justify-center mb-5 group-hover:bg-accent-100 transition-colors">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${article.icon} text-lg text-foreground-600 group-hover:text-accent-600 transition-colors`}></i>
                </div>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 leading-snug">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-500 font-light leading-relaxed mb-4">
                {article.description}
              </p>
              <span className="inline-flex items-center gap-1.5 text-sm font-medium text-foreground-700 group-hover:text-accent-600 transition-colors whitespace-nowrap">
                Ler mais
                <div className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}